export const pluginDefaultPriority = 50;
export const invalidReasonAttributeName = 'data-exeditor-invalid-reason';
export var DOMType;
(function (DOMType) {
    DOMType["MARK"] = "mark";
    DOMType["NODE"] = "node";
    DOMType["BLOCK"] = "block";
    DOMType["INLINE"] = "inline";
    DOMType["INLINE_BLOCK"] = "inlineBlock";
})(DOMType || (DOMType = {}));
export var ChildrenDOMType;
(function (ChildrenDOMType) {
    ChildrenDOMType["BLOCK"] = "block+";
    ChildrenDOMType["INLINE"] = "inline*";
    ChildrenDOMType["NONE"] = "none";
})(ChildrenDOMType || (ChildrenDOMType = {}));
export var SchemaType;
(function (SchemaType) {
    SchemaType["NODE"] = "node";
    SchemaType["MARK"] = "mark";
})(SchemaType || (SchemaType = {}));
// 这些 dom 事件会被核心监听并通过 eventemitter
// 接口透传出去
export const simpleEvents = [
    'focus',
    'compositionstart',
    'compositionupdate',
    'compositionend',
];
//# sourceMappingURL=constants.js.map